import classes from "./SiderContentC.module.css";
import { Menu, message } from "antd";

import signInSignUpLogo from "../../../assets/signInSignUp.png";
import { MdDashboard , MdAssignmentTurnedIn} from "react-icons/md";
// import { NavLink } from "react-router-dom";
import { Link } from "react-router-dom";
import axios from "axios";
import { FaUser, FaSignOutAlt } from "react-icons/fa"

import { useNavigate } from "react-router-dom";
import { AiFillFileMarkdown, AiFillPropertySafety } from "react-icons/ai";



const { SubMenu } = Menu;

const SiderContentS = (props) => {
  const history = useNavigate();

  const handleLogout = (event) => {
    axios
      .get(props.url + "/api/v1/users/logout", {
        withCredentials: true,
      })
      .then((response) => {
        message.success({
          content: "Goodbye!!!! See You Again!!!",
          className: "custom-class",
          style: {
            marginTop: "20vh",
          },
        });
        history("/");
      })
      .catch((err) => {
        // console.log(err);
      });
  };

  return (
    <>
      <img
        className={classes["SignInSignUpLogo"]}
        src={signInSignUpLogo}
        alt="Logo"
      />
      <Menu
        mode="inline"
        defaultSelectedKeys={["empDashboard"]}
        // defaultOpenKeys={["misc"]}
        style={{
          height: "100%",
          borderRight: 0,
          overflowY: "auto",
        }}
        theme="light"
      >
        <Menu.Item key="userDashboard" icon={<MdDashboard />}>
          <Link to="/admin/dashboard" style={{ textDecoration: "none" }}>
            Dashboard
          </Link>
        </Menu.Item>

        <Menu.Item key="user" icon={<FaUser />}>
          <Link to="/admin/employee/emp-detail" style={{ textDecoration: "none" }}>
            New User
          </Link>
        </Menu.Item>



        <Menu.Item key="module" icon={<AiFillPropertySafety />}>
          <Link to="/admin/users" style={{ textDecoration: "none" }}>
            Module Rights
          </Link>
        </Menu.Item>

        {/* <Menu.Item key="userDashboard" icon={<MdDashboard />}>
          <Link to="/admin/dashboard" style={{ textDecoration: "none" }}>
            Dashboard
          </Link>
        </Menu.Item> */}
        <Menu.Item key="userright" icon={<MdAssignmentTurnedIn />}>
          <Link to="/admin/users/rights" style={{ textDecoration: "none" }}>
            Form Rights
          </Link>
        </Menu.Item>

        <Menu.Item key="userrighttyu" icon={<AiFillFileMarkdown />}>
          <Link to="/admin/users/unit" style={{ textDecoration: "none" }}>
           Unit Master
          </Link>
        </Menu.Item>
       
{/* 
        <SubMenu
          key="masters"
          title="masters"
          icon={<MdAssignmentTurnedIn />}
        >
          <Menu.Item key="Salesformorder">
            <Link
              to="/finance/transaction/voucher-detail"
              style={{ textDecoration: "none" }}
            >
              Vouchers
            </Link>
          </Menu.Item>
          <Menu.Item key="Salesform">
            <Link
              to="/finance/transaction/control"
              style={{ textDecoration: "none" }}
            >
              Control Room
            </Link>
          </Menu.Item>
          <Menu.Item key="Ledger">
            <Link
              to="/finance/transaction/ledger"
              style={{ textDecoration: "none" }}
            >
              Ledger
            </Link>
          </Menu.Item>

          <Menu.Item key="Trail">
            <Link
              to="/finance/transaction/trail-balance"
              style={{ textDecoration: "none" }}
            >
              Trail Balance
            </Link>
          </Menu.Item>
          
        </SubMenu>

        */}

        <Menu.Item
          key="empLogout"
          onClick={(event) => handleLogout(event)}
          icon={<FaSignOutAlt style={{ color: "red", opacity: "0.7" }} />}
        >
          <Link to="/" style={{ textDecoration: "none" }}>
            Logout
          </Link>
        </Menu.Item> 
      </Menu>
    </>
  );
};

export default SiderContentS;
